import {
  GET_FEATURE_DEFINITIONS,
  GET_FEATURE_DEFINITIONS_SUCCESS,
  GET_FEATURE_DEFINITIONS_FAIL,
  GET_FEATURE_STATUS,
  GET_FEATURE_STATUS_SUCCESS,
  GET_FEATURE_STATUS_FAIL,
  GRANT_TRIAL_FEATURE,
  GRANT_TRIAL_FEATURE_SUCCESS,
  GRANT_TRIAL_FEATURE_FAIL,
  REVOKE_TRIAL_FEATURE,
  REVOKE_TRIAL_FEATURE_SUCCESS,
  REVOKE_TRIAL_FEATURE_FAIL,
  GET_ORGANISATION_DETAILS,
  GET_ORGANISATION_DETAILS_SUCCESS,
  GET_ORGANISATION_DETAILS_FAIL,
  CLEAR_FEATURE_ERROR
} from '../reducers/organisationDetailReducer'

/**
 * Fetch available feature definitions for admins
 */
export const getFeatureDefinitions = () => {
  console.log('getFeatureDefinitions action created')
  return {
    type: GET_FEATURE_DEFINITIONS,
    payload: {
      request: {
        url: 'feature-flags/definitions',
        method: 'GET'
      }
    }
  }
}

/**
 * Fetch organisation details including feature flags
 */
export const getOrganisationDetails = (organisationId) => {
  console.log('getOrganisationDetails action created for org:', organisationId)
  return {
    type: GET_ORGANISATION_DETAILS,
    payload: {
      request: {
        url: `dashboard/organisations/${organisationId}`,
        method: 'GET'
      }
    }
  }
}

/**
 * Grant a trial feature to an organisation
 */
export const grantTrialFeature = (organisationId, featureName, durationDays = 14, indefinite = false) => {
  return {
    type: GRANT_TRIAL_FEATURE,
    payload: {
      request: {
        url: `feature-flags/grant-trial/${organisationId}`,
        method: 'POST',
        data: {
          featureName,
          durationDays: indefinite ? 0 : parseInt(durationDays),
          reason: indefinite ? 'manual' : 'trial',
          indefinite
        }
      }
    }
  }
}

/**
 * Revoke a trial feature from an organisation
 */
export const revokeTrialFeature = (organisationId, featureName) => {
  console.log('revokeTrialFeature action created')
  return {
    type: REVOKE_TRIAL_FEATURE,
    payload: {
      request: {
        url: `feature-flags/revoke/${organisationId}`,
        method: 'POST',
        data: {
          featureName
        }
      }
    }
  }
}

/**
 * Clear feature error message
 */
export const clearFeatureError = () => {
  return {
    type: CLEAR_FEATURE_ERROR
  }
}
